<template>
  <div class="d-flex flex-column" style="gap: 2px; align-items: flex-start">
    <div v-if="params.data.statusPruefungAkzeptiert">
      <b-button
        size="sm"
        variant="success"
        :disabled="!isBearbeitbarDurch"
        v-b-modal="isBearbeitbarDurch ? 'modalFlugbuchungZuruecksetzen' + params.data.id : null"
      >
        Akzeptiert
      </b-button>
    </div>
    <div v-else>
      <b-button
        variant="secondary"
        :disabled="!isBearbeitbarDurch"
        v-b-modal="isBearbeitbarDurch ? 'modalFlugbuchungAkzeptieren' + params.data.id : null"
        size="sm"
        class="p-1"
      >
        Nicht akzeptiert
      </b-button>
    </div>

    <b-modal
      size="md"
      :id="'modalFlugbuchungAkzeptieren' + params.data.id"
      centered
      title="Vorgang Status Prüfung akzeptieren"
    >
      <b-overlay :show="isLoading">
        <h6 class="mb-12">Möchtest du den Vorgang {{ params.data.id }} wirklich akzeptieren?</h6>
        <b-form-group
          label="Kommentar"
          :invalid-feedback="'Kommentar ist erforderlich'"
          :state="kommentar.trim() !== '' ? null : false"
        >
          <b-form-input v-model="kommentar" type="text" :state="kommentar.trim() !== '' ? null : false" />
        </b-form-group>
      </b-overlay>
      <template #modal-footer="{ hide }">
        <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
        <b-button
          class="dialog-btn"
          variant="danger"
          :disabled="kommentar.trim() === ''"
          @click="changeVorgangAkzeptiertStatus(true, hide)"
        >
          Akzeptieren
        </b-button>
      </template>
    </b-modal>

    <b-modal
      size="md"
      :id="'modalFlugbuchungZuruecksetzen' + params.data.id"
      centered
      title="Vorgang Status Prüfung zurücksetzen"
    >
      <b-overlay :show="isLoading">
        <h6 class="">Möchtest du den Vorgang {{ params.data.id }} wirklich zurücksetzen?</h6>
      </b-overlay>
      <template #modal-footer="{ hide }">
        <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
        <b-button class="dialog-btn" variant="danger" @click="changeVorgangAkzeptiertStatus(false, hide)">
          Zurücksetzen
        </b-button>
      </template>
    </b-modal>
    <div v-if="params.data.warStatusPruefungAkzeptiert">
      <b-badge variant="secondary">War akzeptiert</b-badge>
    </div>
  </div>
</template>

<script>
import store from '@/core/common/services/vuex-store.js';
import { Role } from '@/core/user/roles.js';

export default {
  data() {
    return {
      isLoading: false,
      kommentar: '',
    };
  },
  computed: {
    statusPruefungGruen() {
      return this.params.data.statusPruefung === 'AllGood';
    },
    isBearbeitbarDurch() {
      const roles = store.getters.customRoles ? store.getters.customRoles : store.getters.parsedRoles;
      return roles.includes(Role.ADMIN) || roles.includes(Role.FOM);
    },
  },
  methods: {
    changeVorgangAkzeptiertStatus(status, hide) {
      if (!this.params.onClickAkzeptiertStatusPruefung) return;
      this.params.onClickAkzeptiertStatusPruefung(this.params.data.id, this.kommentar, status, hide);
    },
  },
};
</script>
<style scoped>
.btn:disabled {
  cursor: default;
}
</style>
